import cn from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';

import { Avatar } from '@/shared/ui';

import styles from './ClinicRow.module.scss';

type ClinicRowProps = {
  id: string;
  organizationName: string;
  initials: string;
  avatarSrc: string;
  isCurrent?: boolean;
  isMFARequired?: boolean;
  onClick: (id: string) => void;
};

export const ClinicRow = (props: ClinicRowProps) => {
  const {
    id,
    organizationName,
    avatarSrc,
    initials,
    isCurrent,
    isMFARequired,
    onClick,
  } = props;

  const { formatMessage } = useIntl();

  const handleClick = () => {
    onClick(id);
  };

  return (
    <button
      type="button"
      data-component="clinic-row"
      className={styles.container}
      onClick={handleClick}
    >
      <Avatar
        className={styles.avatar}
        src={avatarSrc}
        initials={initials}
        alt={organizationName}
        size={isCurrent ? 62 : 48}
      />
      <div className={styles.info}>
        <p className="p1m">{organizationName}</p>
        {isCurrent && (
          <span className={cn(styles.settings, 'p2')}>
            {formatMessage({
              id: 'global.settings',
              defaultMessage: 'Settings',
            })}
          </span>
        )}
      </div>

      {isMFARequired && (
        <span className={cn(styles.mfaMarker, 'p4b')}>
          <FormattedMessage
            id="controlPanel.myClinics.codeRequired"
            defaultMessage="Code required"
          />
        </span>
      )}
    </button>
  );
};
